module.exports = {
  address: "0xa672a2c2AFE36345F0c8396537B241D45B97E0f2",
  address_test: '0xD2503CF72dC0173d8F35c20F077c9Da784620F06',
  abi: require('./Claim.abi.json')
}
